import React from 'react';
import PropTypes from 'prop-types';
import { labelColorsByTrackStatus } from "../../../config/styles";
import { TRACK_STATUS_CLOSED, TRACK_STATUS_OPEN, TRACK_STATUS_WAITING } from "../../../config/constants";

const TrackStatusIcon = ({ status, size }) => {
	const style = size ? {
		width: size,
		height: size,
		padding: 3
	} : null;

	const styleInner = size ? {
		width: size - 6,
		height: size - 6
	} : null;

	return (
		<div
			className="track-status-icon"
			style={{
				backgroundColor: labelColorsByTrackStatus[status][0],
				...style
			}}
		>
			<i className="track-status-icon-inner"
				 style={{
					 backgroundColor: labelColorsByTrackStatus[status][1],
					 ...styleInner
				 }}
			/>
		</div>
	)
};

TrackStatusIcon.propTypes = {
	status: PropTypes.oneOf([
		TRACK_STATUS_OPEN,
		TRACK_STATUS_CLOSED,
    TRACK_STATUS_WAITING
	])
};

export default TrackStatusIcon;
